// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var Lhs$ReactHooksTemplate = require("./lhs.res.js");
var Nps$ReactHooksTemplate = require("./Nps.res.js");
var DropDown$ReactHooksTemplate = require("./DropDown.res.js");
var Question$ReactHooksTemplate = require("./Question.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var DateCondition$ReactHooksTemplate = require("./DateCondition.res.js");
var ListCondition$ReactHooksTemplate = require("./ListCondition.res.js");
var MultipleChoice$ReactHooksTemplate = require("./MultipleChoice.res.js");
var MultipleSelect$ReactHooksTemplate = require("./MultipleSelect.res.js");
var NumberCondition$ReactHooksTemplate = require("./NumberCondition.res.js");
var StringCondition$ReactHooksTemplate = require("./StringCondition.res.js");

function id(t) {
  return t.id;
}

function conditionType(t) {
  return t.conditionType;
}

function setConditionType(t, conditionType) {
  return {
          id: t.id,
          conditionType: conditionType
        };
}

function lhs(t) {
  var x = t.conditionType;
  switch (x.TAG) {
    case "NumberCondition" :
        return NumberCondition$ReactHooksTemplate.lhs(x._0);
    case "StringCondition" :
        return StringCondition$ReactHooksTemplate.lhs(x._0);
    case "ListCondition" :
        return ListCondition$ReactHooksTemplate.lhs(x._0);
    case "DateCondition" :
        return DateCondition$ReactHooksTemplate.lhs(x._0);
    
  }
}

function setLhs(t, lhs) {
  var x = t.conditionType;
  switch (x.TAG) {
    case "NumberCondition" :
        return {
                TAG: "NumberCondition",
                _0: NumberCondition$ReactHooksTemplate.setLhs(x._0, lhs)
              };
    case "StringCondition" :
        return {
                TAG: "StringCondition",
                _0: StringCondition$ReactHooksTemplate.setLhs(x._0, lhs)
              };
    case "ListCondition" :
        return {
                TAG: "ListCondition",
                _0: ListCondition$ReactHooksTemplate.setLhs(x._0, lhs)
              };
    case "DateCondition" :
        return {
                TAG: "DateCondition",
                _0: DateCondition$ReactHooksTemplate.setLhs(x._0, lhs)
              };
    
  }
}

function evaluate(t) {
  var x = t.conditionType;
  switch (x.TAG) {
    case "NumberCondition" :
        return NumberCondition$ReactHooksTemplate.evaluate(x._0);
    case "StringCondition" :
        return StringCondition$ReactHooksTemplate.evaluate(x._0);
    case "ListCondition" :
        return ListCondition$ReactHooksTemplate.evaluate(x._0);
    case "DateCondition" :
        return DateCondition$ReactHooksTemplate.evaluate(x._0);
    
  }
}

function emptyCondition(idOpt, groupIdOpt, lhs) {
  var id = idOpt !== undefined ? Caml_option.valFromOption(idOpt) : undefined;
  var groupId = groupIdOpt !== undefined ? Caml_option.valFromOption(groupIdOpt) : undefined;
  if (lhs.TAG === "Question") {
    var question = lhs._0;
    var nps = question.questionType;
    switch (nps.TAG) {
      case "Nps" :
          var condition_lhs = {
            TAG: "Question",
            _0: question
          };
          var condition_operator = List.hd(NumberCondition$ReactHooksTemplate.availableOperators());
          var condition_rhs = Nps$ReactHooksTemplate.includeZero(nps._0) ? 0 : 1;
          var condition = {
            lhs: condition_lhs,
            operator: condition_operator,
            rhs: condition_rhs,
            groupId: groupId
          };
          return {
                  id: id,
                  conditionType: {
                    TAG: "NumberCondition",
                    _0: condition
                  }
                };
      case "MultipleChoice" :
          var rhs = List.hd(MultipleChoice$ReactHooksTemplate.choices(nps._0));
          var condition_lhs$1 = {
            TAG: "Question",
            _0: question
          };
          var condition_operator$1 = List.hd(ListCondition$ReactHooksTemplate.availableOperators({
                    TAG: "Question",
                    _0: question
                  }, undefined));
          var condition_rhs$1 = {
            hd: rhs,
            tl: /* [] */0
          };
          var condition$1 = {
            lhs: condition_lhs$1,
            operator: condition_operator$1,
            rhs: condition_rhs$1,
            groupId: undefined
          };
          return {
                  id: id,
                  conditionType: {
                    TAG: "ListCondition",
                    _0: condition$1
                  }
                };
      case "MultipleSelect" :
          var rhs$1 = List.hd(MultipleSelect$ReactHooksTemplate.answerList(nps._0));
          var condition_lhs$2 = {
            TAG: "Question",
            _0: question
          };
          var condition_operator$2 = List.hd(ListCondition$ReactHooksTemplate.availableOperators({
                    TAG: "Question",
                    _0: question
                  }, undefined));
          var condition_rhs$2 = {
            hd: rhs$1,
            tl: /* [] */0
          };
          var condition$2 = {
            lhs: condition_lhs$2,
            operator: condition_operator$2,
            rhs: condition_rhs$2,
            groupId: undefined
          };
          return {
                  id: id,
                  conditionType: {
                    TAG: "ListCondition",
                    _0: condition$2
                  }
                };
      case "DropDown" :
          var rhs$2 = List.hd(DropDown$ReactHooksTemplate.answerList(nps._0));
          var condition_lhs$3 = {
            TAG: "Question",
            _0: question
          };
          var condition_operator$3 = List.hd(ListCondition$ReactHooksTemplate.availableOperators({
                    TAG: "Question",
                    _0: question
                  }, undefined));
          var condition_rhs$3 = {
            hd: rhs$2,
            tl: /* [] */0
          };
          var condition$3 = {
            lhs: condition_lhs$3,
            operator: condition_operator$3,
            rhs: condition_rhs$3,
            groupId: undefined
          };
          return {
                  id: id,
                  conditionType: {
                    TAG: "ListCondition",
                    _0: condition$3
                  }
                };
      case "LongText" :
      case "ShortText" :
      case "MobileNumber" :
          break;
      default:
        var condition_lhs$4 = {
          TAG: "Question",
          _0: question
        };
        var condition_operator$4 = List.hd(NumberCondition$ReactHooksTemplate.availableOperators());
        var condition_rhs$4 = 1;
        var condition$4 = {
          lhs: condition_lhs$4,
          operator: condition_operator$4,
          rhs: condition_rhs$4,
          groupId: groupId
        };
        return {
                id: id,
                conditionType: {
                  TAG: "NumberCondition",
                  _0: condition$4
                }
              };
    }
    var condition_lhs$5 = {
      TAG: "Question",
      _0: question
    };
    var condition_operator$5 = List.hd(StringCondition$ReactHooksTemplate.availableOperators());
    var condition_rhs$5 = /* [] */0;
    var condition$5 = {
      lhs: condition_lhs$5,
      operator: condition_operator$5,
      rhs: condition_rhs$5
    };
    return {
            id: id,
            conditionType: {
              TAG: "StringCondition",
              _0: condition$5
            }
          };
  }
  var dataField = lhs._0;
  var match = DataField$ReactHooksTemplate.dataType(dataField);
  switch (match.TAG) {
    case "ListType" :
        var condition_lhs$6 = {
          TAG: "DataField",
          _0: dataField
        };
        var condition_operator$6 = List.hd(ListCondition$ReactHooksTemplate.availableOperators({
                  TAG: "DataField",
                  _0: dataField
                }, undefined));
        var condition_rhs$6 = /* [] */0;
        var condition$6 = {
          lhs: condition_lhs$6,
          operator: condition_operator$6,
          rhs: condition_rhs$6,
          groupId: undefined
        };
        return {
                id: id,
                conditionType: {
                  TAG: "ListCondition",
                  _0: condition$6
                }
              };
    case "NumberType" :
        var condition_lhs$7 = {
          TAG: "DataField",
          _0: dataField
        };
        var condition_operator$7 = List.hd(NumberCondition$ReactHooksTemplate.availableOperators());
        var condition_rhs$7 = 0;
        var condition$7 = {
          lhs: condition_lhs$7,
          operator: condition_operator$7,
          rhs: condition_rhs$7,
          groupId: groupId
        };
        return {
                id: id,
                conditionType: {
                  TAG: "NumberCondition",
                  _0: condition$7
                }
              };
    default:
      var condition_lhs$8 = {
        TAG: "DataField",
        _0: dataField
      };
      var condition_operator$8 = List.hd(StringCondition$ReactHooksTemplate.availableOperators());
      var condition_rhs$8 = /* [] */0;
      var condition$8 = {
        lhs: condition_lhs$8,
        operator: condition_operator$8,
        rhs: condition_rhs$8
      };
      return {
              id: id,
              conditionType: {
                TAG: "StringCondition",
                _0: condition$8
              }
            };
  }
}

function decodeConditionType(json, questions, dataFields) {
  var conditionType = Json_decode.field("condition_type", Json_decode.string, json);
  switch (conditionType) {
    case "date_condition" :
        return {
                TAG: "DateCondition",
                _0: DateCondition$ReactHooksTemplate.decode(json, questions, dataFields)
              };
    case "list_condition" :
        return {
                TAG: "ListCondition",
                _0: ListCondition$ReactHooksTemplate.decode(json, questions, dataFields)
              };
    case "number_condition" :
        return {
                TAG: "NumberCondition",
                _0: NumberCondition$ReactHooksTemplate.decode(json, questions, dataFields)
              };
    case "string_condition" :
        return {
                TAG: "StringCondition",
                _0: StringCondition$ReactHooksTemplate.decode(json, questions, dataFields)
              };
    default:
      return Js_exn.raiseError("Unknown trigger type");
  }
}

function decode(json, questions, dataFields) {
  return {
          id: Json_decode.field("id", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json),
          conditionType: decodeConditionType(json, questions, dataFields)
        };
}

function encodeConditionType(t) {
  var match = t.conditionType;
  switch (match.TAG) {
    case "NumberCondition" :
        return "number_condition";
    case "StringCondition" :
        return "string_condition";
    case "ListCondition" :
        return "list_condition";
    case "DateCondition" :
        return "date_condition";
    
  }
}

function lhsId(t) {
  var x = t.conditionType;
  switch (x.TAG) {
    case "NumberCondition" :
        return Lhs$ReactHooksTemplate.id(NumberCondition$ReactHooksTemplate.lhs(x._0));
    case "StringCondition" :
        return Lhs$ReactHooksTemplate.id(StringCondition$ReactHooksTemplate.lhs(x._0));
    case "ListCondition" :
        return Lhs$ReactHooksTemplate.id(ListCondition$ReactHooksTemplate.lhs(x._0));
    case "DateCondition" :
        return Lhs$ReactHooksTemplate.id(DateCondition$ReactHooksTemplate.lhs(x._0));
    
  }
}

function lhsName(t) {
  var x = t.conditionType;
  switch (x.TAG) {
    case "NumberCondition" :
        return Lhs$ReactHooksTemplate.name(NumberCondition$ReactHooksTemplate.lhs(x._0));
    case "StringCondition" :
        return Lhs$ReactHooksTemplate.name(StringCondition$ReactHooksTemplate.lhs(x._0));
    case "ListCondition" :
        return Lhs$ReactHooksTemplate.name(ListCondition$ReactHooksTemplate.lhs(x._0));
    case "DateCondition" :
        return Lhs$ReactHooksTemplate.name(DateCondition$ReactHooksTemplate.lhs(x._0));
    
  }
}

function lhsGroupId(t) {
  var x = t.conditionType;
  switch (x.TAG) {
    case "NumberCondition" :
        return NumberCondition$ReactHooksTemplate.groupId(x._0);
    case "ListCondition" :
        return ListCondition$ReactHooksTemplate.groupId(x._0);
    case "StringCondition" :
    case "DateCondition" :
        return ;
    
  }
}

function isSentimentCondition(t) {
  var x = t.conditionType;
  if (x.TAG === "ListCondition") {
    return ListCondition$ReactHooksTemplate.isSentimentCondition(x._0);
  } else {
    return false;
  }
}

function emptySentimentCondition(idOpt, question) {
  var id = idOpt !== undefined ? Caml_option.valFromOption(idOpt) : undefined;
  var condition_lhs = {
    TAG: "Question",
    _0: question
  };
  var condition_rhs = {
    hd: [
      "negative",
      "Negative"
    ],
    tl: /* [] */0
  };
  var condition_groupId = ListCondition$ReactHooksTemplate.sentimentGroupId;
  var condition = {
    lhs: condition_lhs,
    operator: "is_any_of",
    rhs: condition_rhs,
    groupId: condition_groupId
  };
  return {
          id: id,
          conditionType: {
            TAG: "ListCondition",
            _0: condition
          }
        };
}

function isLongTextQuestionLhs(t) {
  var question = lhs(t);
  if (question.TAG !== "Question") {
    return false;
  }
  var match = Question$ReactHooksTemplate.questionType(question._0);
  if (match.TAG === "LongText") {
    return true;
  } else {
    return false;
  }
}

function operator(t) {
  var x = t.conditionType;
  switch (x.TAG) {
    case "NumberCondition" :
        return NumberCondition$ReactHooksTemplate.operator(x._0);
    case "StringCondition" :
        return StringCondition$ReactHooksTemplate.operator(x._0);
    case "ListCondition" :
        return ListCondition$ReactHooksTemplate.operator(x._0);
    case "DateCondition" :
        return DateCondition$ReactHooksTemplate.operator(x._0);
    
  }
}

function encodeRhs(t) {
  var x = t.conditionType;
  switch (x.TAG) {
    case "NumberCondition" :
        return NumberCondition$ReactHooksTemplate.encodeRhs(x._0);
    case "StringCondition" :
        return StringCondition$ReactHooksTemplate.encodeRhs(x._0);
    case "ListCondition" :
        return ListCondition$ReactHooksTemplate.encodeRhs(x._0);
    case "DateCondition" :
        return DateCondition$ReactHooksTemplate.encodeRhs(x._0);
    
  }
}

function toJson(destroyOpt, t) {
  var destroy = destroyOpt !== undefined ? destroyOpt : false;
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "lhs_id",
                  Json_encode.nullable((function (prim) {
                          return prim;
                        }), lhsId(t))
                ],
                tl: {
                  hd: [
                    "lhs_type",
                    lhsName(t)
                  ],
                  tl: {
                    hd: [
                      "operator",
                      operator(t)
                    ],
                    tl: {
                      hd: [
                        "condition_type",
                        encodeConditionType(t)
                      ],
                      tl: {
                        hd: [
                          "rhs",
                          encodeRhs(t)
                        ],
                        tl: {
                          hd: [
                            "group_id",
                            Json_encode.nullable((function (prim) {
                                    return prim;
                                  }), lhsGroupId(t))
                          ],
                          tl: {
                            hd: [
                              "_destroy",
                              destroy
                            ],
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

exports.id = id;
exports.conditionType = conditionType;
exports.setConditionType = setConditionType;
exports.lhsName = lhsName;
exports.operator = operator;
exports.encodeRhs = encodeRhs;
exports.lhs = lhs;
exports.setLhs = setLhs;
exports.emptyCondition = emptyCondition;
exports.emptySentimentCondition = emptySentimentCondition;
exports.isSentimentCondition = isSentimentCondition;
exports.isLongTextQuestionLhs = isLongTextQuestionLhs;
exports.decode = decode;
exports.toJson = toJson;
exports.evaluate = evaluate;
/* Lhs-ReactHooksTemplate Not a pure module */
